import React,{Component} from 'react';
import './Index.css'
import '../../assets/css/font-awesome.css'
import {logo1} from '../../sharedcomponents/ImageScope'
// import {NavLink} from 'react-router-dom'
export default class Footer extends Component{
    render(){
        return(
            <div>
                <footer className="footer_area">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="footer_top flex-column">
                                <div className="footer_logo">
                                    <img src={logo1} style={{width:'48px',height:'48px'}} alt=""/>
                                    <h4 style={{marginTop:'0',fontFamily: 'Myriad Pro Bold',fontWeight:'500', color:'#333'}}>Siga-nos</h4>
                                </div>
                                <div className="footer_social">
                                    <a href="https://www.facebook.com/hsdesignangola"><i className="fa fa-facebook"></i></a>
                                    <a href="https://www.instagram.com/hs_design_angola/"><i className="fa fa-instagram"></i></a>
                                    <a href="https://api.whatsapp.com/send?1=ao&phone=244946869867"><i className="fa fa-whatsapp"></i></a>
                                </div>
                            </div>
                        </div>
					</div>
					<hr style={{marginTop:'-15px'}}/>
					<div  className="  d-flex-m  address-wrap">
						<div className="single-contact-address d-flex-c">
							<div className="icon">
								<span className="lnr lnr-home"></span>
							</div>
							<div className="contact-details">
								<h5 style={{fontFamily: 'Myriad Pro Bold',fontWeight:'500', color:'#333'}}>Cassenda, Luanda</h5>
								<p>
									Rua 6 Bloco 77b, Ap/12/ R/C 
								</p>
							</div>
						</div>
						<div className="single-contact-address d-flex-c">
							<div className="icon">
								<span className="lnr lnr-phone-handset"></span>
							</div>
							<div className="contact-details">
								<h5 style={{fontFamily: 'Myriad Pro Bold',fontWeight:'500', color:'#333'}}>(+244) 948 576 847</h5>
								<p>Segunda a Sexta das 8 ás 18h </p>
							</div>
						</div>
						<div className="single-contact-address d-flex-c">
							<div className="icon">
								<span className="lnr lnr-envelope"></span>
							</div>
							<div className="contact-details">
								<h5 style={{fontFamily: 'Myriad Pro Bold',fontWeight:'500', color:'#333'}}>hsdesignangola@gmail.com</h5>
								<p>Envia-nos a sua mengasem</p>
							</div>
						</div>
					</div>
					<hr/>
                    <div className="row footer_bottom justify-content-center">
                        <p className="col-lg-8 col-sm-12 footer-text">
                        Copyright &copy; HS Design { new Date().getFullYear()} | Todos direitos reservados | feito com muito <i class="fa fa-heart-o" aria-hidden="true"></i> por <a href="https://codepro.com" target="_blank" rel="noopener noreferrer">Code Pro</a>
                        </p>
                    </div>
                </div>
                </footer>
            </div>
        );
    }
}